import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import authService from '../services/authService';
import '../styles/UserProfile.css';

export default function UserProfile() {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();
  const isAuthenticated = authService.isAuthenticated();

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    username: user?.username || '',
    email: user?.email || '',
  });

  // Redirect if not authenticated
  React.useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  if (!user) {
    return null;
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditToggle = () => {
    if (isEditing) {
      // Reset form data if canceling
      setFormData({
        username: user.username,
        email: user.email,
      });
    }
    setIsEditing(!isEditing);
  };

  const handleSave = () => {
    // TODO: Implement API call to update user profile
    console.log('Saving profile:', formData);

    // Update localStorage for now
    const updatedUser = {
      ...user,
      username: formData.username,
      email: formData.email,
    };
    localStorage.setItem('userInfo', JSON.stringify(updatedUser));

    setIsEditing(false);
    window.location.reload(); // Refresh to update UI
  };

  const getRoleDisplay = (roles) => {
    if (!roles || roles.length === 0) return 'User';
    return roles.map(role => role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()).join(', ');
  };

  return (
    <>
      <Header activePage="" />
      <main className="profile-page">
        <div className="profile-container">
          <div className="profile-header">
            <div className="profile-avatar-large">
              <span className="profile-avatar-text">{user.username.charAt(0).toUpperCase()}</span>
            </div>
            <h1 className="profile-title">My Profile</h1>
          </div>

          <div className="profile-content">
            <div className="profile-section">
              <h2 className="section-title">Account Information</h2>

              <div className="profile-info-grid">
                <div className="info-group">
                  <label className="info-label">Username</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                      className="info-input"
                    />
                  ) : (
                    <p className="info-value">{user.username}</p>
                  )}
                </div>

                <div className="info-group">
                  <label className="info-label">Email</label>
                  {isEditing ? (
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="info-input"
                    />
                  ) : (
                    <p className="info-value">{user.email}</p>
                  )}
                </div>

                <div className="info-group">
                  <label className="info-label">Role</label>
                  <p className="info-value">{getRoleDisplay(user.roles)}</p>
                </div>

                <div className="info-group">
                  <label className="info-label">Account Status</label>
                  <p className="info-value">
                    <span className="status-badge active">Active</span>
                  </p>
                </div>
              </div>

              <div className="profile-actions">
                {isEditing ? (
                  <>
                    <button className="btn-primary" onClick={handleSave}>
                      Save Changes
                    </button>
                    <button className="btn-secondary" onClick={handleEditToggle}>
                      Cancel
                    </button>
                  </>
                ) : (
                  <button className="btn-primary" onClick={handleEditToggle}>
                    Edit Profile
                  </button>
                )}
              </div>
            </div>

            <div className="profile-section">
              <h2 className="section-title">Security</h2>
              <div className="security-options">
                <button className="security-btn">
                  <span>Change Password</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button className="security-btn">
                  <span>Two-Factor Authentication</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <div className="profile-section">
              <h2 className="section-title">Preferences</h2>
              <div className="preferences-grid">
                <div className="preference-item">
                  <div className="preference-info">
                    <h3 className="preference-title">Email Notifications</h3>
                    <p className="preference-description">Receive updates about your consultations</p>
                  </div>
                  <label className="toggle-switch">
                    <input type="checkbox" defaultChecked />
                    <span className="toggle-slider"></span>
                  </label>
                </div>

                <div className="preference-item">
                  <div className="preference-info">
                    <h3 className="preference-title">Newsletter</h3>
                    <p className="preference-description">Get weekly astrology insights</p>
                  </div>
                  <label className="toggle-switch">
                    <input type="checkbox" defaultChecked />
                    <span className="toggle-slider"></span>
                  </label>
                </div>

                <div className="preference-item">
                  <div className="preference-info">
                    <h3 className="preference-title">SMS Reminders</h3>
                    <p className="preference-description">Reminders for upcoming appointments</p>
                  </div>
                  <label className="toggle-switch">
                    <input type="checkbox" />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
